import React, { useState } from 'react';
import { useSelector } from 'react-redux';

export default function TabComponent({ accordionComponents, submitButton }) {
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (newValue) => {
    setActiveTab(newValue);
  };

  const isLastTab = activeTab === accordionComponents.length - 1;

  const handleNext = () => {
    const nextIndex = activeTab + 1;
    if (nextIndex < accordionComponents.length) {
      setActiveTab(nextIndex);
    }
  };

  return (
    <div className="div-flex-column horizontal-padding-10">
      <div className={`div-flex-row theme-tab-background-color-${themeColor}`}>
        <div className="div-flex-row w-100 div-space-between div-align-center">
          <div className="div-flex-row cg-20">
            {accordionComponents?.map((section, index) => (
              <div
                key={section.id}
                onClick={() => handleChange(index)}
                role="button"
                tabIndex={0}
                className={`${activeTab === index ? 'tab-select' : 'tab-unselect'} ${
                  section.error ? 'text-red' : `theme-text-color-${themeColor}`
                }`}
              >
                <span
                  className={`
                  text-sm text-nowrap text-semi-bold ${section.indicator ? 'pulse-text' : ''}`}
                >
                  {section.title}
                </span>
              </div>
            ))}
          </div>
          <div>
            {isLastTab ? (
              submitButton
            ) : (
              <button
                className={`common-btn-filled theme-background-${themeColor}`}
                onClick={handleNext}
              >
                Next
              </button>
            )}
          </div>
        </div>
      </div>
      {accordionComponents?.map(
        (section, index) =>
          activeTab === index && (
            <div key={section.id}>{section.component}</div>
          ),
      )}
    </div>
  );
}
